module.exports = __webpack_public_path__ + "static/media/donut-chart-decreased.eeb96d91.svg";